// Business info shared across the frontend. Keep this in sync with the
// backend `/api/business` response.
export const BUSINESS = {
  name: "Gens Realty",
  location: "Houston, TX",
  phone: "(346) 699-2755",
  phoneTel: "+13466992755",
  email: "hello@gensrealty.com",
};
